import auth from '@/core/lib/router/auth.route';
import common from '@/core/lib/router/common.route';
import contribution from '@/core/lib/router/contribution.route';
import conversations from '@/core/lib/router/conversations.route';
import donations from '@/core/lib/router/donations.route';
import favorites from '@/core/lib/router/favorites.route';
import notificationPushRoute from '@/core/lib/router/notificationpush.route';
import profile from '@/core/lib/router/profile.route';

const Routes = {
  ...auth,
  ...common,
  ...conversations,
  ...donations,
  ...favorites,
  ...profile,
  ...notificationPushRoute,
  ...contribution,
};

export default Routes;
